import * as React from 'react';
import { ListPage } from '../../../ui';
import { GeneralCompetencyEventListFilter, GeneralCompetencyEventList } from './index';

class GeneralCompetencyEventListPage extends React.PureComponent {
  render() {
    return (
      <ListPage filter={<GeneralCompetencyEventListFilter/>}>
        <GeneralCompetencyEventList/>
      </ListPage>
    );
  }
}

export default GeneralCompetencyEventListPage;
